import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import dayjs from 'dayjs';
import { useCookies } from 'react-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import { IInAppProps, ICoupon } from 'utils/types/saleTypes';
import { noticeTypeList, PublicStateEnhance } from 'utils/constant';
import TableToolbar from 'components/table/TableToolbar';
import SearchInput from 'components/search/SearchInput';
import MainTable from 'components/table/MainTable';
import NoImage from 'components/etc/NoImage';
import TextButton from 'components/button/TextButton';
import DefaultButton from 'components/button/DefaultButton';
import { useTranslation } from 'react-i18next';
import { IProject } from '../../../utils/types/storyTypes';
import { productApis } from '../../../apis/package/productApis';
import { FaApple } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import { Trash } from 'iconsax-react';
import DeleteModal from '../../../components/modal/DeleteModal';
import InAppRegisterModal from '../../sales/inappStore/InAppRegisterModal';
import PublicState from '../../../components/etc/PublicState';
import UtcTimer from '../../../components/etc/UtcTimer';
import CapsuleButton from '../../../components/button/CapsuleButton';
import DeletePopConfirm from '../../../components/button/DeletePopConfirm';
import { INotice } from '../../../utils/types/operationTypes';
import { oldNoticeApi } from '../../../apis/operation/oldNoticeApis';
import { noticeApis } from '../../../apis/operation/noticeApis';
// import { sortableHandle } from 'react-sortable-hoc';
import { MenuOutlined } from '@ant-design/icons';
import NoticeRegisterModal from './NoticeRegisterModal';

/**
 * * 판매 - 인앱 상점 관리 - 목록
 */

interface IProps {
  selectProject: IProject;
}

const NewNoticeListPage = ({ selectProject }: IProps) => {
  const { t } = useTranslation();
  const { id, masterId } = useParams();

  const [cookies] = useCookies();
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState();
  const [notices, setNotices] = useState<INotice[]>([]);
  const [visible, setVisible] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedNotice, setselectedNotice] = useState<INotice>();

  const handleLink = (notice: INotice) => (e) => {
    navigate(`/notice/${selectProject.project_id}/${notice.notice_id}`);
  };

  const handleClickDeleteModal = (notice: INotice) => {
    setselectedNotice(notice);
    setDeleteModalOpen(true);
  };

  const fetchData = async () => {
    const res = await noticeApis.getNoticeList(selectProject.project_id);
    setNotices(res);
  };

  const columnsOrigin = [
    {
      title: 'id',
      align: 'center',
      dataIndex: 'notice_id',
      sorter: (a, b) => a.notice_id - b.notice_id,
    },
    {
      title: t('ifYou.table.productURL'),
      dataIndex: 'notice_id',
      width: '6rem',
      align: 'center',
      render: (_, record: INotice) => {
        const lang = cookies.lang ? cookies.lang : 'KO';
        const langObject = record.details.find((obj) => obj.lang === lang);

        return langObject?.banner_url ? (
          <Image
            src={langObject.banner_url}
            height={80}
            style={{ objectFit: 'contain' }}
          />
        ) : (
          <NoImage />
        );
      },
    },
    {
      title: t('notice.table.internalName'),
      dataIndex: 'notice_name',
      width: '15rem',
      sorter: (a, b) => a.notice_name.localeCompare(b.notice_name),
      render: (text, record: INotice) => (
        <TextButton onClick={handleLink(record)}>{text}</TextButton>
      ),
    },
    {
      title: t('notice.table.startDate'),
      dataIndex: 'from_date',
      width: '10rem',
      render: (text) => (
        <>
          <p>{text.slice(0, -3)}</p>
          <UtcTimer startDate={text} />
        </>
      ),
      sorter: (a, b) => a.start_date.localeCompare(b.start_date),
    },
    {
      title: t('notice.table.endDate'),
      dataIndex: 'to_date',
      width: '10rem',
      render: (text) => (
        <>
          <p>{text.slice(0, -3)}</p>
          <UtcTimer endDate={text} />
        </>
      ),
      sorter: (a, b) => a.end_date.localeCompare(b.end_date),
    },
    {
      title: t('notice.table.action'),
      dataIndex: 'move',
      width: '10rem',
      render: (text, record: INotice) => (
        <div>
          <Trash
            size='24'
            onClick={() => {
              handleClickDeleteModal(record);
            }}
          />
        </div>
      ),
    },
  ];

  const handleDelete = async () => {
    setLoading(true);
    await noticeApis.deleteNotice(
      selectProject.project_id,
      selectedNotice!.notice_id,
    );
    fetchData();
    setDeleteModalOpen(false);
    setLoading(false);
  };

  useEffect(() => {
    fetchData().catch(console.log);
  }, [selectProject]);

  return (
    <>
      <TableToolbar>
        <SearchInput
          setSearchData={setSearchData}
          placeholder={t('ifYou.header.inputPlaceHolder')}
        />
        <div>
          <DefaultButton
            name='register'
            onClick={() => setVisible(true)}
            disabled={false}
          >
            {t('ifYou.header.registerButton')}
          </DefaultButton>
        </div>
      </TableToolbar>

      <MainTable columns={columnsOrigin} dataSource={notices} />

      <NoticeRegisterModal
        visible={visible}
        setVisible={setVisible}
        fetchData={fetchData}
      />

      <DeleteModal
        visible={deleteModalOpen}
        setVisible={setDeleteModalOpen}
        title={'공지 삭제'}
        content={''}
        label={selectedNotice?.notice_name}
        handleDelete={handleDelete}
        loading={loading}
      />
    </>
  );
};

export default NewNoticeListPage;
